import React from 'react';

import { StyledOcticon } from '@primer/react';

export const Icon = ({
  icon,
  size = 16,
  fill = 'white',
  useTailwindSizing = false,
  ...rest
}) => (
  <StyledOcticon
    fill={fill}
    size={useTailwindSizing ? size / 4 : size}
    icon={icon}
    {...rest}
  />
)

export default Icon;
